import { render, staticRenderFns } from "./DJ.vue?vue&type=template&id=59858373&"
import script from "./DJ.vue?vue&type=script&lang=js&"
export * from "./DJ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports